App.namespace.wrap('views.shared.detect_device', () => {
  const iOS = function () {
    return navigator.userAgent.indexOf('iPhone') != -1 || navigator.userAgent.indexOf('iPad') != -1;
  };

  const mac = function () {
    return navigator.userAgent.indexOf('Mac OS X') != -1;
  };

  const windowsPhone = function () {
    return navigator.userAgent.indexOf('IEMobile') != -1;
  };

  if (iOS()) {
    $('body').addClass('ios');
  }

  if (windowsPhone()) {
    $('body').addClass('windows-phone');
  }

  if (mac()) {
    $('body').addClass('osx');
  }
});
